import { Attributes, Misc, ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class UpdateExportFileSpecCommand extends ModelBase {

    public staticExportFileSpecId: number = 0;

    public exportName: string = "";

    public exportReportReference: string = "";

    public format: string = "";

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public activeStartDate: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public activeEndDate: Date | null = null;
}